export default __webpack_public_path__ + "static/media/start.98e80d9b.svg";